import React from "react";

import Checkbox from "@mui/material/Checkbox";

const Checkbox_ = ({ id, checked, onChange, color = "primary" }) => {
  return (
    <Checkbox
      key={id}
      size="small"
      color={color}
      checked={checked}
      onChange={e => onChange(id, e.target.checked)}
    />
  );
};

export default Checkbox_;
